import React, { useState } from 'react';
import { Box, TextField, Chip, Typography, IconButton } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import AddIcon from '@mui/icons-material/Add';

export interface FormTagsInputProps {
  name: string;
  label: string;
}

export const FormTagsInput: React.FC<FormTagsInputProps> = ({
  name,
  label,
}) => {
  const { control } = useFormContext();
  const [tagInput, setTagInput] = useState('');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const tags = field.value || [];

        const handleAddTag = () => {
          if (tagInput.trim() && !tags.includes(tagInput.trim())) {
            field.onChange([...tags, tagInput.trim()]);
            setTagInput('');
          }
        };

        const handleDeleteTag = (tagToDelete: string) => {
          field.onChange(tags.filter((tag: string) => tag !== tagToDelete));
        };

        return (
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              {label}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
              {tags.map((tag: string) => (
                <Chip
                  key={tag}
                  label={tag}
                  onDelete={() => handleDeleteTag(tag)}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <TextField
                size="small"
                value={tagInput}
                onChange={(e) => setTagInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddTag();
                  }
                }}
                placeholder="Add a tag"
              />
              <IconButton onClick={handleAddTag} color="primary">
                <AddIcon />
              </IconButton>
            </Box>
          </Box>
        );
      }}
    />
  );
};
